import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';

const extractUrlParams = (
  keys: DeeplinkKeys[]
): Partial<Record<DeeplinkKeys, string>> => {
  const params = getContext().general.location.getState().params ?? {};

  return keys.reduce<Partial<Record<DeeplinkKeys, string>>>((acc, key) => {
    const value = params[key];

    return value ? { ...acc, [key]: value } : acc;
  }, {});
};

export default extractUrlParams;
